import {
  faChevronLeft,
  faUserAlt,
  // faUserLock,
  // faUserNinja,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import './Account.css';
import { connect } from 'react-redux';

import AccountService from '../../service/account/AccountService';
import { AccountLoginModel } from '../../model/AccountLoginModel';
import { AccountLoginValidatorService } from '../../service/validation/AccountLoginValidatorService.js';
import Loading from '../shared/UI/Loading';
import { Redirect } from 'react-router-dom';
import { accountActionType } from '../../redux/actions/auth/accountAction';
import Translation from 'i18next';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountLoginValidatorState: new AccountLoginValidatorService(), //new accountLoginValidatorService(),
      logging: false,
      redirectToCheckout: false,
      errorMsg: '',
    };
    this.accountLogin = new AccountLoginModel();
    this.accountLoginValidator = new AccountLoginValidatorService(); //new accountLoginValidatorService();
    document.title = 'Ethiopian Duty Free | Login';
  }

  handleFormSubmit = (event) => {
    event.preventDefault();

    this.setState({
      accountLoginValidatorState: this.state.accountLoginValidatorState.validateAccountLoginInfo(
        this.accountLogin
      ).AccountLoginValidation,
    });
    this.accountLoginValidator = this.state.accountLoginValidatorState.validateAccountLoginInfo(
      this.accountLogin
    ).AccountLoginValidation;
    var tempValidForm = true;

    for (let i = 0; i < this.accountLoginValidator.accountLoginValidLists.length; i++) {
      if (!this.accountLoginValidator.accountLoginValidLists[i]) {
        tempValidForm = false;
        break;
      }
    }
    if (tempValidForm) {
      var accountServiceObj = new AccountService();
      this.setState({ logging: true });

      accountServiceObj
        .loginToDutyFree(this.props.clientToken, {
          email: this.accountLogin.email,
          password: this.accountLogin.password,
        })
        .then((response) => {
          this.props.updateIsSignIn(true);
          this.props.updateCustomerInfo(response.data);
          this.props.updatePaymentOptions(response.data.paymentOptions);
          this.setState({ logging: false, redirectToCheckout: true });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            var errorMessage = '';
            if (error.response.data.errors.Username !== undefined) {
              errorMessage = error.response.data.errors.Username[0];
            }
            if (errorMessage !== '' && error.response.data.errors.Password !== undefined) {
              errorMessage = errorMessage + ', ';
            }
            if (error.response.data.errors.Password !== undefined) {
              errorMessage = errorMessage + error.response.data.errors.Password[0];
            }
            this.setState({ errorMsg: errorMessage });
          }
          if (error.response.status === 500) {
            this.setState({ errorMsg: error.response.data.message });
          }
          console.log(error.response.status, error.response.data.message);
          this.setState({ logging: false });
        });
    }
  };
  onInputKeyDown = (accountLoginValidator) => {
    this.setState({
      accountLoginValidatorState: accountLoginValidator,
      errorMsg: '',
    });
  };

  accountService = new AccountService();

  render() {
    if (this.state.redirectToCheckout) {
      return (
        <Redirect
          to={{
            pathname: this.accountService.getRedirectUrl(this.props.location.search),
          }}
        />
      );
    }
    return (
      <section className="light-background-color" style={{ minHeight: '50vh', padding: '2rem 0' }}>
        {this.state.logging ? <Loading /> : null}
        <Container className="container shebamiles-login-container">
          <Row>
            <Col xs={12} sm={12} md={8} lg={5} xl={4} className="m-auto">
              <Card
                style={{
                  paddingBottom: '3rem',
                  boxShadow: '0 5px 10px #eee',
                  borderRadius: '10px',
                }}
              >
                <p style={{ marginBottom: '3em' }}></p>
                <FontAwesomeIcon
                  icon={faUserAlt}
                  size="3x"
                  className="d-flex align-self-center text-success"
                />
                <br />
                <div className="pb-4">
                  <h3 className="text-center py-3">{Translation.t('login to sheba duty free')}</h3>
                </div>

                <div className="sheba-miles-login mx-4">
                  <Form onSubmit={this.handleFormSubmit}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="float-left">
                        {Translation.t('username')} <span>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={
                          this.state.accountLoginValidatorState.isEmailValid
                            ? ''
                            : this.accountLoginValidator.errors.email
                        }
                        onChange={(event) => (this.accountLogin.email = event.target.value)}
                        className={
                          this.state.accountLoginValidatorState.isEmailValid
                            ? 'input-field'
                            : 'invalid-input-field'
                        }
                        onKeyDown={() => {
                          this.accountLoginValidator.isEmailValid = true;
                          this.onInputKeyDown(this.accountLoginValidator);
                        }}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label className="float-left">
                        {Translation.t('password')} <span>*</span>
                      </Form.Label>
                      <Form.Control
                        type="password"
                        placeholder={
                          this.state.accountLoginValidatorState.isPasswordValid
                            ? ''
                            : this.accountLoginValidator.errors.password
                        }
                        onChange={(event) => (this.accountLogin.password = event.target.value)}
                        className={
                          this.state.accountLoginValidatorState.isPasswordValid
                            ? 'input-field'
                            : 'invalid-input-field'
                        }
                        onKeyDown={() => {
                          this.accountLoginValidator.isPasswordValid = true;
                          this.onInputKeyDown(this.accountLoginValidator);
                        }}
                        required
                      />
                    </Form.Group>
                    {this.state.errorMsg !== '' ? (
                      <span className="d-block text-left text-danger dty-fr-input-field-validation-error">
                        {this.state.errorMsg}
                      </span>
                    ) : null}
                    <a href="/forgot-password" className="float-right py-1 forgot-password-link">
                      {Translation.t('forgot password')}?
                    </a>
                    <p style={{ marginBottom: '5.5em' }}></p>
                    <Button className="float-left duty-free-outline-primary-btn" href="/account">
                      <FontAwesomeIcon icon={faChevronLeft} />
                      <span className="px-2">{Translation.t('back')}</span>
                    </Button>
                    <button
                      // variant="primary"
                      type="submit"
                      className="float-right btn-primary-et btn px-3 py-2"
                    >
                      {Translation.t('login')}
                    </button>
                  </Form>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    clientToken: state.authClient.clientToken,
    accessToken: state.authAccess.accessToken,
    cart: state.cart.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateIsSignIn: (value) =>
      dispatch({
        type: accountActionType.UPDATEISSIGNIN,
        value: value,
      }),
    updateCustomerInfo: (value) =>
      dispatch({
        type: accountActionType.UPDATECUSTOMERINFOMATION,
        value: value,
      }),
    updatePaymentOptions: (value) =>
      dispatch({
        type: accountActionType.UPDATEPAYMENTOPTIONS,
        value: value,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
